import React from 'react';
import { Consultation } from './components/Consultation';
import { Hero } from './components/Hero';
import { Process } from './components/Process';
import { ProjectGallery } from './components/ProjectGallery';
import { Reviews } from './components/Reviews';
import { Services } from './components/Services';
import { SiteFooter } from './components/SiteFooter';
import { SiteHeader } from './components/SiteHeader';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-[#fbfaf6] font-heading text-[#173d36]" data-id="element-0">
      <SiteHeader data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <Process data-id="element-5" />
        <ProjectGallery data-id="element-6" />
        <Reviews data-id="element-7" />
        <Consultation data-id="element-8" />
      </main>
      <SiteFooter data-id="element-9" />
    </div>;
}